import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	performanceAndScale: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale',
		defaultMessage: 'Site optimizer',
		description: 'Navigation item which links to Jira site optimizer section',
	},
	itemBack: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.item-back',
		defaultMessage: 'Back to system',
		description: '"Back to System" menu item.',
	},
	spotlightHeading: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-heading',
		defaultMessage: 'Clean up your site',
		description: 'Spotlight title',
	},
	spotlightBody: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-body',
		defaultMessage: 'Remove old data that might be slowing down your site in a few clicks.',
		description: 'Spotlight body text',
	},
	spotlightAction: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-action',
		defaultMessage: 'Ok',
		description: 'Spotlight action, ends the onboarding tour',
	},
	beta: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.beta',
		defaultMessage: 'Beta',
		description: 'Label for beta template lozenge',
	},
});
